import { Component, input, output } from '@angular/core';
import { AlertComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../../core/i18n';
import type { PickupDateOption } from '../mappers/map-pickup-availability';

/**
 * Figma “Select Your Pickup Date” radios (node 19018:57772).
 * Emits the selected `yyyy-MM-dd` date; the page owns state updates.
 * Supports a soft availability notice above radios (e.g. same-day cutoff) while still
 * allowing the customer to pick the next eligible date.
 */
@Component({
  selector: 'app-pickup-dates-section',
  imports: [TypographyComponent, TranslatePipe, AlertComponent],
  templateUrl: './pickup-dates-section.component.html',
  styleUrl: './pickup-dates-section.component.scss',
})
export class PickupDatesSectionComponent {
  readonly dates = input.required<PickupDateOption[]>();
  readonly selectedDate = input<string | null>(null);
  readonly loading = input(false);
  /** Blocking error — hides date radios. */
  readonly errorMessage = input<string | null>(null);
  /** Soft notice — shown with date radios when dates are available. */
  readonly noticeMessage = input<string | null>(null);

  /** Emits the newly selected pickup date (`yyyy-MM-dd`). */
  readonly dateChange = output<string>();

  /**
   * Emits a date selection from the radio group.
   */
  protected onDateSelect(date: string): void {
    this.dateChange.emit(date);
  }
}
